"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const veflux_1 = require("vasat/dist/src/veflux");
/**
 * representation of the cursor, fired on the MapEvent.cursorStream when changed.
 * This item is a memory only object and can carry data via its 'meta' field. It is typicaly set by a clickHandler,
 * though it could be set by anything else too.
 */
class Cursor {
    constructor(coodinate, icon, meta) {
        this.coodinate = coodinate;
        this.icon = icon;
        this.meta = meta;
    }
}
exports.Cursor = Cursor;
class ProjectEvent extends veflux_1.BaseEvent {
}
exports.ProjectEvent = ProjectEvent;
/**
 * Specific event for scene changes
 */
class SceneEvent extends veflux_1.BaseEvent {
}
exports.SceneEvent = SceneEvent;
/**
 * Specific event for layers changes
 */
class LayerEvent extends veflux_1.BaseSimpleEvent {
}
exports.LayerEvent = LayerEvent;
/**
 * Specific event for photos
 */
class PhotoEvent extends veflux_1.BaseSimpleEvent {
}
exports.PhotoEvent = PhotoEvent;
/**
 * Specific event for photos
 */
class AnnotationEvent extends veflux_1.BaseSimpleEvent {
}
exports.AnnotationEvent = AnnotationEvent;
/**
 * Specific event for cursor changes
 */
class CursorEvent extends veflux_1.BaseSimpleEvent {
}
exports.CursorEvent = CursorEvent;
/**
 * Specific event for map
 */
class MapEvent extends veflux_1.BaseSimpleEvent {
}
exports.MapEvent = MapEvent;
/**
 * Specific event for map
 */
class CameraEvent extends veflux_1.BaseEvent {
}
exports.CameraEvent = CameraEvent;
class JobEvent extends veflux_1.BaseEvent {
}
exports.JobEvent = JobEvent;
/**
 * Specific events from drobbox syncs etc
 */
class SyncAgentEvent extends veflux_1.BaseSimpleEvent {
}
exports.SyncAgentEvent = SyncAgentEvent;
